export class AS4QueryParams {
    requestId: string;
    conversationId: string;
    dateFrom: string;
    dateTo: string;
    fromParty: string;
    toParty: string;
    type: string;
}